import React, { Fragment, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Formik, Field } from 'formik';
import {
  RenderTextField,
  required,
} from '../../../components/FormElements/FormikElements';
import { Icon } from 'merchant-portal-components';
import { Button } from 'merchant-portal-components';
import logo from '../../../../public/img/logo-invite-user-page.png';
import { InputAdornment, TextField } from '@material-ui/core';
import { validateChangePasswordFields } from '../newUserLoginAction';
import PasswordVerifier from '../../PasswordVerifier/PasswordVerifier';
import { connect } from 'react-redux';
import { useAppCode } from '../../../hooks/use-app-code';
import { getAppBaseURL } from '../../Account/actions';

const Content = styled.div`
  padding: 48px 95px 40px 95px;
  width: 550px;
  height: 780px;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);
  background-color: white;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
`;

const Title = styled.div`
  font-size: 21px;
  font-weight: 600;
  line-height: 1.29;
  letter-spacing: 0.03px;
  color: #191818;
`;

const Subtitle = styled.div`
  font-size: 16px;
  font-weight: normal;
  line-height: 1.29;
  letter-spacing: 0.03px;
  color: #191818;
  margin-top: 16px;
  margin-bottom: 32px;
`;

const PasswordMismatchSpan = styled.span`
  font-size: 12px;
  font-family: 'Montserrat';
  color: red;
  letter-spacing: -0.02px;
  margin-bottom: 8px;
  margin-top: -20px;
`;

const FormWrapper = styled.div`
  display: grid;
  grid-gap: 32px;
`;

const ButtonDiv = styled.div`
  margin-top: 35px;
  margin-left: 190px;
`;

const Logo = styled.img`
  height: 50px;
  margin-bottom: 8px;
`;

const NewUserLogin = ({
  postNewUser,
  params,
  history,
  getAppBaseURL,
  accountReducer,
  ...rest
}) => {
  const { isRouteUpdatedByAppCode } = accountReducer;
  const [appCodeTouched, setAppCodeTouched] = useState(false);
  const [state, setState] = useState({
    passwordMaskState: true,
    passwordConfirmMaskState: true,
    isRegisterButtonDisabled: true,
  });
  const token = params.token;
  const { handleAppCodeChange } = useAppCode(getAppBaseURL, false);
  const queryParams = new URLSearchParams(window.location.search);
  const appCode = queryParams.get('appCode');
  useEffect(() => {
    if (appCode) {
      getAppBaseURL(appCode);
    }
  }, [appCode]);
  return (
    <Content>
      <Logo src={logo} alt='Smooth Commerce'></Logo>
      <Title>Welcome to Portal</Title>
      <Subtitle>
        Please complete your profile information to get started
      </Subtitle>
      <FormWrapper>
        <Formik
          validate={(values) => {
            const err = validateChangePasswordFields(values);
            if (Object.keys(err).length === 0) {
              setState({
                ...state,
                isRegisterButtonDisabled: false,
              });
            } else {
              setState({
                ...state,
                isRegisterButtonDisabled: true,
              });
            }
            return err;
          }}
        >
          {({ values, isValid }) => (
            <Fragment>
              {appCode && (
                <TextField
                  id='Login-appCode'
                  variant='outlined'
                  label='App Code'
                  value={appCode}
                  onChange={handleAppCodeChange}
                  placeholder='App Code'
                  type='text'
                  style={{ height: '48px' }}
                  disabled={true}
                  onBlur={() => setAppCodeTouched(true)}
                  error={!appCode && appCodeTouched}
                  helperText={!appCode && appCodeTouched ? 'Required' : ''}
                  margin='normal'
                />
              )}
              <Field
                type={state.passwordMaskState ? 'password' : 'text'}
                name='password'
                label='Choose a password'
                component={RenderTextField}
                validate={required}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <Icon
                        className={
                          state.passwordMaskState
                            ? 'fas fa-eye'
                            : 'fas fa-eye-slash'
                        }
                        onClick={() =>
                          setState({
                            ...state,
                            passwordMaskState: !state.passwordMaskState,
                          })
                        }
                      />
                    </InputAdornment>
                  ),
                }}
                disabled={!isRouteUpdatedByAppCode}
              />
              <div>
                <PasswordVerifier
                  password={values.password}
                  passwordConfirm={values.passwordConfirm}
                />
              </div>
              <Field
                type={state.passwordConfirmMaskState ? 'password' : 'text'}
                name='passwordConfirm'
                label='Confirm password'
                component={RenderTextField}
                validate={required}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <Icon
                        className={
                          state.passwordConfirmMaskState
                            ? 'fas fa-eye'
                            : 'fas fa-eye-slash'
                        }
                        onClick={() =>
                          setState({
                            ...state,
                            passwordConfirmMaskState:
                              !state.passwordConfirmMaskState,
                          })
                        }
                      />
                    </InputAdornment>
                  ),
                }}
                disabled={!isRouteUpdatedByAppCode}
              />
              <ButtonDiv>
                <Button
                  onClick={() => postNewUser(values, token, history)}
                  disabled={
                    state.isRegisterButtonDisabled ||
                    !isRouteUpdatedByAppCode ||
                    !isValid
                  }
                >
                  Register
                </Button>
              </ButtonDiv>
            </Fragment>
          )}
        </Formik>
      </FormWrapper>
    </Content>
  );
};

const mapStateToProps = (state) => ({
  passwordVerifier: state.passwordVerifierReducer,
  accountReducer: state.accountReducer,
});

export default connect(mapStateToProps, { getAppBaseURL })(NewUserLogin);
